import { TemplateWrapped } from "../../../Layout";
import { HeaderButton } from "../../../RemarkTemplate/Body";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import React, { useContext, useState } from "react";
import PermissionContext from "../context/PermissionContext";
import PermissionForm from "./PermissionForm";
import PermissionsList from "./PermissionsList";

const PermissionsWrapped = ({ theme }) => {
  const { createSection, sections } = useContext(PermissionContext);

  const [showModal, setShowModal] = useState(false);
  return (
    <TemplateWrapped
      title="Permissions"
      headerButtons={
        <HeaderButton
          icon={faPlus}
          message="Add section"
          onClick={() => {
            setShowModal(true);
          }}
          active={false}
          theme={theme}
        />
      }
      showTitle={false}
    >
      <main className="flex-1 pt-[3rem] pb-8">
        {/* Page Header */}
        <div className="mb-8 flex justify-between items-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Permissions</h1>
          <HeaderButton
            icon={faPlus}
            message="Add section"
            onClick={() => {
              setShowModal(true);
            }}
            theme={theme}
            active={true}
          />
        </div>
        {sections.length > 0 ? (
          <PermissionsList list={sections} type={"section"} theme={theme} />
        ) : (
          <div>
            Dear user, there is no permissions yet, please try to create one
          </div>
        )}
      </main>

      {showModal ? (
        <PermissionForm
          initialValues={{
            type: "Module",
          }}
          onCancel={() => setShowModal(false)}
          onSave={(values) =>
            createSection(values).then((r) => setShowModal(false))
          }
          theme={theme}
        />
      ) : null}
    </TemplateWrapped>
  );
};

export default PermissionsWrapped;
